/**
 * Shared chat formatting utilities.
 * Used by both HomeMessage and Message (Business) components.
 */

/**
 * Format a timestamp for the LHS conversation list.
 * Today → "10:42 AM"
 * Yesterday → "Yesterday"
 * This week → "Mon"
 * Older → "Feb 27"
 */
export const formatChatTimestamp = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();

    const isToday = date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear();

    if (isToday) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // "10:42 AM"
    } else if (isYesterday) {
        return 'Yesterday';
    } else if (now - date < 7 * 24 * 60 * 60 * 1000) {
        return date.toLocaleDateString([], { weekday: 'short' }); // "Mon"
    } else {
        return date.toLocaleDateString([], { month: 'short', day: 'numeric' }); // "Feb 27"
    }
};

/**
 * Format a timestamp for individual message bubbles (RHS).
 * Always returns short time: "5:10 AM"
 */
export const formatMessageTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // "5:10 AM"
};

/**
 * Format a date for the day-group separator pill in the chat area.
 * Today → "Today"
 * Yesterday → "Yesterday"
 * Older → "Feb 27, 2026"
 */
export const formatDateSeparator = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();

    const isToday = date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear();

    if (isToday) {
        return 'Today';
    } else if (isYesterday) {
        return 'Yesterday';
    } else {
        return date.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' }); // "Feb 27, 2026"
    }
};

/**
 * Check if two date strings fall on different calendar days.
 * Used to determine where to insert date separator pills.
 */
export const isDifferentDay = (dateStr1, dateStr2) => {
    if (!dateStr1 || !dateStr2) return true;
    const d1 = new Date(dateStr1);
    const d2 = new Date(dateStr2);
    return d1.getDate() !== d2.getDate() ||
        d1.getMonth() !== d2.getMonth() ||
        d1.getFullYear() !== d2.getFullYear();
};
